/******/ (() => { // webpackBootstrap
          var __webpack_exports__ = {};
          Shopify.theme.jsFAQ = {
          init: function() {

  const $faqHeading = jQuery('.faq-accordion > dt > button');

  jQuery('.faq-accordion > dd').attr('aria-hidden',true);

  $faqHeading.attr('aria-expanded',false);

  $faqHeading.each(function(index,element){
    if(jQuery(element).hasClass('listenerAdded') == false){
      jQuery(element).addClass('listenerAdded');
      jQuery(element).on('click',function(){
        const faqTitle = jQuery(this);
        const faqIcons = jQuery(this).find('.icon');

        let state = jQuery(this).attr('aria-expanded') === 'false' ? true : false;
        jQuery(this).attr('aria-expanded',state);
        jQuery(this).parent().next().slideToggle(function(){

          if(faqIcons.hasClass('icon--active')) {
            faqIcons.toggleClass('icon--active');
          }

        });
        jQuery(this).parent().next().attr('aria-hidden',!state);
        return false;
      })
    }
  });

  //     $faqHeading.on('click activate',function(){

  //       const faqTitle = jQuery(this);
  //       const faqIcons = jQuery(this).find('.icon');

  //       let state = jQuery(this).attr('aria-expanded') === 'false' ? true : false;
  //       jQuery(this).attr('aria-expanded',state);
  //       jQuery(this).parent().next().slideToggle(function(){

  //         if(faqIcons.hasClass('icon--active')) {
  //           faqIcons.toggleClass('icon--active');
  //         }

  //       });
  //         jQuery(this).parent().next().attr('aria-hidden',!state);
  //       return false;
  //     });

  $faqHeading.on('keydown',function(event){
    let keyCode = event.keyCode || e.which;
    if (keyCode === 13){
      jQuery(this).trigger('activate');
    }
  });

},
  unload: function() {
    jQuery('.faq-accordion > dt > button').off('click activate');
    jQuery('.faq-accordion > dt > button').off('keydown');
  }
}
/******/ })()
;